// app/components/roles/PermissionsGrid.jsx
import React from 'react';

const PermissionsGrid = ({ permissions, rolePermissions, onToggle, disabled }) => {
    // Group permissions by resource
    const groupedPermissions = permissions.reduce((acc, perm) => {
        if (!acc[perm.resource]) {
            acc[perm.resource] = [];
        }
        acc[perm.resource].push(perm);
        return acc;
    }, {});

    const formatResource = (resource) => {
        return resource.charAt(0).toUpperCase() + resource.slice(1);
    };

    if (disabled) {
        return (
            <div className="p-6 text-center text-gray-500">
                Select a role to manage permissions
            </div>
        );
    }

    return (
        <div className="p-4">
            <div className="space-y-6">
                {Object.entries(groupedPermissions).map(([resource, perms]) => (
                    <div key={resource}>
                        <h4 className="font-medium text-gray-900 mb-3">
                            {formatResource(resource)}
                        </h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {perms.map((permission) => (
                                <label
                                    key={permission.id}
                                    className="flex items-center space-x-3 p-3 border rounded-lg hover:bg-gray-50 cursor-pointer"
                                >
                                    <input
                                        type="checkbox"
                                        checked={rolePermissions.includes(permission.id)}
                                        onChange={() => onToggle(permission.id)}
                                        className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
                                    />
                                    <div className="flex-1">
                                        <p className="font-medium text-sm text-gray-900 capitalize">
                                            {permission.action}
                                        </p>
                                        <p className="text-xs text-gray-500">
                                            {permission.description}
                                        </p>
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PermissionsGrid;